import { productImpression } from 'analytics/enhanced-ecommerce'
import { productImpressionObject } from 'analytics/eventDefinitions'
import { TrackingProps } from 'contexts/trackingContext'
import { useEffect, useRef } from 'react'
import { reportError } from '../../../services/errorReportingService'

/**
 * This will not work for "progressive" loading UI where the original order can change.
 * https://aussiecommerce.atlassian.net/wiki/spaces/REC/pages/2353397765/REC-231+Tracking+impression+positions
 */
function useTrackOfferImpressions(
  offers: Array<App.Offer | Tours.V2Offer | App.BedbankOffer | App.BedbankOfferSummary | App.OfferSummary>,
  tracking: TrackingProps | undefined,
  readyToTrack: boolean,
  currency: string,
) {
  const offerIdsLoadImpressionTracked = useRef<Record<string, boolean>>({})
  const lastPosition = useRef(0)

  useEffect(() => {
    try {
      if (!readyToTrack || !tracking) {
        return
      }

      const offersNotTracked = offers.filter(offer => offer?.id && !offerIdsLoadImpressionTracked.current[offer.id])
      if (offersNotTracked.length === 0) {
        return
      }

      offersNotTracked.forEach((offer) => {
        offerIdsLoadImpressionTracked.current[offer.id] = true
      })
      productImpression(
        currency,
        offersNotTracked.map((offer: App.OfferSummary | App.BedbankOfferWithRate | Tours.V2Offer, i) =>
          productImpressionObject(offer, tracking.listName, i + 1 + lastPosition.current)),
        {
          listId: tracking.listId,
          listName: tracking.listName,
        },
        {
          ...(tracking.lere ? { lereVersion: tracking.lere.version } : {}),
        },
      )
      lastPosition.current = offersNotTracked.length
    } catch (e) {
      reportError(e, undefined, undefined, { component: 'lere' })
    }
  }, [currency, offers, tracking, readyToTrack])
}

export default useTrackOfferImpressions
